<template  >


  <v-container v-if="style!==null" style="width:100%;height: calc(100% + 114px);max-width: 100%;margin: 0px 0px 0px;padding:0;overflow: visible !important;" :style="{'backgroundImage':'linear-gradient('+style.START_COLOR+','+ style.END_COLOR+')'}" >

    <div  style="background: url('/api/images/diagmonds.png') repeat;opacity: 0.15;z-index: 0; position: fixed; width: 100%;height: calc(100% + 114px);"></div>
    <v-row class="mx-auto" style="top:100px;width:100%;background: whitesmoke;max-width:80vw;border-radius: 4px;display: block;z-index: 1;position:relative;color:black;" align="start" justify="start">
      <v-col style="height:100px;" cols="12">
          <h2 style="text-align:center;">{{style.SHOP_NAME}}</h2>
          <p style="text-align:center;">{{style.SHOP_DESC}}</p>
        <v-btn @click="show_basket=true" :disabled="order.length===0" style="position:absolute;top:25px;right:90px;" color="green" dark><v-icon left>mdi-cart</v-icon> Betala {{totalCost}} kr </v-btn>
        <v-img  style="position:absolute;left:15px;top:20px;" height="40" width="90" contain :src="require('../assets/swish_light_bg.png')"></v-img>
        <v-img  style="position:absolute;right:15px;top:20px;" height="40" width="90" contain v-if="style.IMAGE!==null && style.IMAGE!==false && style.IMAGE!==0" :src="newImage!==null ? newImage : `/api/images/shops/${style.SID}.png`" ></v-img>



      </v-col>
      <v-col cols="12" style="height: 3px !important; max-height: 6px !important; padding: 0; margin-top: -18px; margin-bottom: 0px; background: #a9a9a9;"></v-col>
      <v-col style="min-height:65vh;max-height:65vh;height:65vh;overflow-y:scroll !important;">
        <v-row style="height:100%;width:100%;" justify="center" align="center">
          <v-col v-for="(product,index) in products" cols="12" md="4" :key="index">
            <v-card
                class="mx-auto my-12"
                max-width="250"
                elevation="10"
            >

              <v-img
                  height="250"
                  width="250"
                  :src="`/api/images/shop_products/${product.PRID}.png?${Math.round(Math.random()*10000)}`"
              >
                <v-chip v-if="prids_in_order[product.PRID]>0" label color="green" style="color:white"><b>x{{ prids_in_order[product.PRID] }}</b><v-btn icon @click="removeFromBasketById(product.PRID)"><v-icon  color="red">mdi-close</v-icon></v-btn></v-chip>



              </v-img>
              <v-chip style="border-radius: 0 !important;" ><b style="margin-right:4px;">{{product.PRICE}} </b> KR</v-chip>

              <v-card-title style="margin-top:-10px;">{{product.NAME}}</v-card-title>

              <v-card-text style="margin-top:-20px;">

                <div>{{product.DESC}}</div>
              </v-card-text>
              <v-card-action>
                <v-btn block dark color="green"
                       @click="add_to_cart(product)"
                >+Lägg till</v-btn>
              </v-card-action>



            </v-card>

          </v-col>

        </v-row>

      </v-col>


    </v-row>
    <v-bottom-sheet v-model="show_basket" inset max-width="700">
      <v-sheet
          class="text-center"
          min-height="200px"


      >
        <v-card v-if="show_basket" flat style="max-width:700px;">
          <v-img  style="position:absolute;left:15px;bottom:10px;" height="40" width="90" contain :src="require('../assets/swish_light_bg.png')"></v-img>


          <v-card-text>
            <v-row v-for="(order_row,index) in order" :key="index" style="height:20px;">
              <v-col  cols="8" style="text-align: left;">
                {{order_row.count}} x {{order_row.product.NAME}}
              </v-col>
              <v-col style="white-space: nowrap;" cols="3" align="right">
                {{order_row.count * order_row.product.PRICE}} kr

              </v-col>
              <v-col cols="1">
                <v-btn @click="removeFromBasket(order_row)" style="margin-top: -4px;" small icon><v-icon small>close</v-icon></v-btn>

              </v-col>


            </v-row>
            <v-divider style="margin-top:10px;"></v-divider>
            <v-row>
              <v-col align="right" cols="11">
                Att betala: {{totalCost}} kr <br> (inkl. 25% moms)

              </v-col>
              <v-col cols="1" >
              </v-col>

            </v-row>

          </v-card-text>
          <v-row align="center" justify="center">
            <v-col style="max-width:300px;margin-top:-40px;" cols="6">
              <v-text-field
                  dense
                  label="Spelarens namn"
                  outlined
                  v-model="recipient_name"



              ></v-text-field>
            </v-col>
            <v-col style="max-width:300px;margin-top:-40px;" cols="6">
              <v-text-field
                  dense
                  label="Ditt telefonnummer"
                  outlined
                  :rules="rules.number"
                  v-model="phone_number"


                  type="number"
                  class="hide_my_spin"

              ></v-text-field>
            </v-col>

          </v-row>
          <v-card-actions>
            <v-btn class="mx-auto"  @click="pay_hicards" color="success">Betala {{totalCost}} KR</v-btn>

          </v-card-actions>


        </v-card>
      </v-sheet>
    </v-bottom-sheet>

























    <SwishModalDonation :amount="amount_selected" :nickname="order_nickname"  :type="pay_for"  :pay_dialog_hihat="pay_dialog_hihat" v-on:donated="done_donate" v-on:hide="pay_dialog_hihat=false"></SwishModalDonation>
    <SwishModalPrivateDonation :amount="amount_selected" :nickname="order_nickname_private"  :type="'Donationen'"  :pay_dialog_private="pay_dialog_private" v-on:donated="done_donate" v-on:hide="pay_dialog_private=false"></SwishModalPrivateDonation>
    <PaymentStatus :show="payment_status" :result="payment_result"></PaymentStatus>
    <v-dialog
        v-model="need_setup"
        max-width="390"

    >
      <v-card style="padding-top: 20px;">
        <div style="text-align: center;width:100%;" class="headline">🚧 Under konstruktion 🚧</div>

        <v-card-text style="text-align: center;margin-top: 10px;">
          Denna sida är inte helt färdig, kom gärna förbi senare!
        </v-card-text>
      </v-card>


    </v-dialog>

    <WebViewHandler></WebViewHandler>



  </v-container>

</template>

<script>


import SwishModalDonation from '../components/SwishModalDonation'
import SwishModalPrivateDonation from "../components/SwishModalPrivateDonation";
import PaymentStatus from '../components/PaymentStatus'
import WebViewHandler from "../components/WebViewHandler";

export default {
  name: "Shop",
  components:{SwishModalPrivateDonation, SwishModalDonation,PaymentStatus,WebViewHandler},
  data:function(){
    return{
      is_paying:false,
      products:[],
      in_bcf:false,
      rules:{
        name:[v => v.length > 2 || 'Ange avsändare'],
        message:[v => v.length <= 249 || 'Max 250 bokstäver', v => v.length > 0 || 'Skriv ett meddelande'],
        amount:[v => v >= this.style.MIN_DONATION|| `Lägsta donation är ${this.style.MIN_DONATION} kronor`],
        number:[function(v){
          let res=v.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
          if(res===0){
            return true
          }
          else{
            return "Ange ditt telefonnummer"
          }

        }],
      } ,
      message: '',
      edit_title:false,
      edit_desc:false,
      title:"",
      desc:"",
      path:"",
      startColor:"#919191",
      endColor:"#4b038d",
      editStartC:false,
      menuStart:false,
      menuEnd:false,
      showImageMenu:false,
      save_style_timeout:null,
      type_selected:0,
      amount_selected:null,
      sheet:null,
      edit_page:false,
      delimiters:[' '],
      accept_terms:false,
      accept_card_terms:false,
      sender_name:"",
      phone_number:"",
      pay_dialog_hihat:false,
      pay_dialog_private:false,
      order_nickname:"",
      order_nickname_private:"",
      page_editable:false,
      style:null,
      newImage:null,
      doneFetching:false,
      renderIndex:0,
      streamer_image:null,
      prompt_setup:false,
      prompt_unfinished:false,
      tab:0,
      basket:[],
      collections:[],
      show_hicards_text:true,
      show_basket:false,
      pay_for:"Donationen",
      streamer_sells_sh:false,
      streamer_has_sh:false,
      collection_select:0,
      name_suggestions:[],
      recipient_name:"",
      prids_in_order: {}





    }
  },
  methods:{

    removeFromBasketById:function(order_prid_to_remove){
      let keep=[];
      this.prids_in_order[order_prid_to_remove]=0;
      for(let i=0;i<this.basket.length;i++){
        if(this.basket[i].PRID!==order_prid_to_remove){
          keep.push(this.basket[i]);
        }
      }
      this.basket=keep;
    },
    removeFromBasket:function(order_to_remove){
      let keep=[];
      this.prids_in_order[order_to_remove.product.PRID]=0;

      for(let i=0;i<this.basket.length;i++){
        if(this.basket[i].PRID!==order_to_remove.product.PRID){
          keep.push(this.basket[i]);
        }
      }
      this.basket=keep;
    },
    add_to_cart:function(product){
      this.prids_in_order[product.PRID]+=1;
      this.basket.push(product)
    },
    get_products:function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let pathname = window.location.pathname.substring(6);

      let url = '/api/get_shop_products?path=' + pathname;
      http.open('GET', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function () {//Call a function when the state changes.


        if (http.readyState === 4 && http.status === 200) {
          if (http.response !== "no data") {

            let respObj = JSON.parse(http.response);
            let products=respObj.products;
            for(let i=0;i<products.length;i++){
              self.prids_in_order[products[i].PRID]=0;
            }
            self.products=products;

          }


        }

      };
      http.send();
    },

    done_donate:function(){
      this.pay_dialog_hihat=false;
      this.pay_dialog_private=false;


      this.phone_number="";
      this.sender_name="";
      this.amount_selected=null;
      this.accept_terms=false;
      this.message="";
      this.renderIndex++;
      this.recipient_name="";
      this.$refs.payment_form.resetValidation();
      this.is_paying=false;
      this.show_basket=false;




    },
    pay_hicards:function(){

      if((typeof this.$store.state.STREAMER.SID)!=="number"){
        this.$store.state.APP.SHOW_LOGIN=true;
      }
      else{

        this.order[0]["totalcost"]=this.totalCost;
        this.order[0]["sender_number"]=this.phone_number;
        this.order[0]["streamername"]=window.location.pathname.substring(6);
        this.order[0]["recipient"]=this.recipient_name;
        this.amount_selected=this.totalCost;
        let http = new XMLHttpRequest();
        http.withCredentials = true;
        let self=this;
        let url = '/api/purchase_products?';
        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json');
        http.onreadystatechange = function() {
          if(http.readyState === 4) {
            if(http.status===200){
              let data = JSON.parse(http.response);
              self.pay_for="Köpet";

              self.pay_dialog_hihat=true;
              self.order_nickname=data["nickname"]

            }
            else{
              self.$store.commit("update_snackbar","Ett fel inträffade");

            }
          }
        };

        http.send(JSON.stringify(this.order));
      }
    },
    pay:function(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/purchase_donation?';
      let pathname=window.location.pathname.substring(1);
      if(lengthInUtf8Bytes(this.message)>255){
        this.message=this.message.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a').replace(/Ä/g, 'A').replace(/Ö/g, 'O').replace(/Å/g, 'A')
      }

      this.sender_name=this.sender_name.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a').replace(/Ä/g, 'A').replace(/Ö/g, 'O').replace(/Å/g, 'A').replace(/[\W_]+/g, '');

      let self=this;
      let params = 'PATH='+pathname+'&senderName='+this.sender_name+'&amount='+parseInt(this.amount_selected)+'&message='+this.message+'&number='+this.phone_number+'&type=message';
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.
        if(http.readyState === 4 && http.status === 412) {
          self.$store.commit("update_snackbar","Vänta ett tag innan du startar en ny donation");

        }
        if(http.readyState === 4 && http.status === 413) {
          self.$store.commit("update_snackbar","Ett fel inträffade");
        }

        else if(http.readyState === 4 && http.status !== 200) {
          self.$store.commit("update_snackbar","Ett fel inträffade");

        }
        else if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          self.pay_for="Donationen";

          if(data["isBank"] || data["isFee"]){
            self.pay_dialog_hihat=true;
            self.order_nickname=data["nickname"]

          }

          else{
            self.pay_dialog_private=true;
            self.order_nickname_private=data["nickname"]
          }
        }

      };
      http.send(params);




    },







    getStyleData(){
      this.doneFetching=false;
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/getShopStyle?';
      let pathname=window.location.pathname.substring(6);
      let params = 'PATH='+pathname;
      http.open('POST', url, true);
      let index=pathname.indexOf("?");
      if(index>0){
        pathname=pathname.substr(0,index);
      }
      let self=this;
      document.title=pathname;
      this.path=pathname;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          if(data["error"]){
            //self.$router.push('/404')
            //self.$router.replace("/404")
          }
          else{

            self.style=data;

            self.set_streamer_image();
          }

        }

      };
      http.send(params);
    },
    set_streamer_image(){
      var image = new Image();
      let self=this;
      image.onload = function() {
        self.streamer_image=image.src
        self.doneFetching=true;

      };
      image.onerror = function() {

        self.streamer_image=`/api/avatar/${self.style.USER_NAME.toLowerCase()}`;
        self.doneFetching=true;

      };

      image.src = "/api/images/users/"+this.style.SID+".png";
    },



  },
  mounted:function(){
    this.getStyleData();
    this.get_products();








  },
  computed:{
    totalCost:function(){
      let total=0;

      for(let i=0;i<this.order.length;i++){
        total+=this.order[i].count*this.order[i].product.PRICE;
      }
      return total
    },
    order:function(){
      let toReturn={};
      for(let i=0;i<this.basket.length;i++){
        if(toReturn[this.basket[i].PRID]===undefined || toReturn[this.basket[i].PRID]===null){
          toReturn[this.basket[i].PRID]={
            count:0,
            product:this.basket[i]
          }
        }
        toReturn[this.basket[i].PRID].count+=1;

      }
      return Object.values(toReturn);


    },

    payments_setup:function(){

      if(this.$store.state.STREAMER.PAYMENT_TYPE==="SWISH" && this.$store.state.STREAMER.PHONE_NUMBER.length>6){
        return true
      }
      else if(this.$store.state.STREAMER.PAYMENT_TYPE==="BANK" && this.$store.state.STREAMER.BANKACCOUNT.length>6 && this.$store.state.STREAMER.PERSONAL_NUMBER.length>6){
        return true
      }
      else{
        return false
      }

    },
    need_setup:function(){
      if(this.style.IS_SETUP===1){
        return false
      }
      else if(this.style.IS_SETUP===0){
        return true
      }
      else{
        return false
      }
    },
    alerts_setup:function(){
      return (this.$store.state.STREAMER.STREAMELEMENTS || this.$store.state.STREAMER.STREAMLABS || this.$store.state.STREAMER.HIHAT)
    },
    dark_mode_text:function(){
      if(this.style.SUGGESTION_TWO){
        return "Mörkt tema"
      }
      else{
        return "Ljust tema"

      }
    },

    ready_to_pay:function(){
      if(parseInt(this.amount_selected)>=parseInt(this.style.MIN_DONATION) && this.accept_terms && this.sender_name.length>2 && this.message.length<250 ){
        let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
        if(res===0){
          return true
        }
        else{
          return false
        }
      }
      else{
        return false
      }
    },
    ready_to_pay_hicards:function(){
      if(this.basket.length>0 && this.accept_card_terms && this.recipient_name.length>2){
        let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
        if(res===0){
          return true
        }
        else{
          return false
        }
      }
      else{
        return false
      }
    },
    payment_status:function(){
      if(this.$route.query.result===undefined){
        return false;
      }
      else{
        return true;
      }

    },
    payment_result:function(){
      if(this.$route.query.result===undefined){
        return ""
      }
      else{
        return this.$route.query.result
      }
    }

  },
  watch:{

    pay_dialog_hihat:function(){
      if(!this.pay_dialog_hihat){
        this.is_paying=false;
        this.show_basket=false;
        this.basket=[];
        let keys=Object.keys(this.prids_in_order);

        for(let i=0;i<keys.length;i++){
          this.prids_in_order[keys[i]]=0;
        }
      }

    },

    recipient_name:function(){
      if(this.recipient_name!==""){
        this.get_name_suggestions();
      }else{
        this.name_suggestions=[];
      }
    },
    '$route': function () {
      this.getStyleData();
    },
    tab: function (newVal) {
      if(newVal===0){
        window.history.replaceState(null, null, window.location.pathname);
      }
      else{
        window.history.replaceState(null, null, window.location.pathname+"?f=sh");

      }
    },

    style:{ handler() {
        if(this.doneFetching && this.page_editable){
          clearTimeout(this.save_style_timeout);
          let self=this;
          this.save_style_timeout=setTimeout(function(){
            self.save_style();
          },1500);
        }

      },deep: true},
    newImage:function(){
      if(this.doneFetching && this.page_editable){
        clearTimeout(this.save_style_timeout);
        let self=this;
        this.save_style_timeout=setTimeout(function(){
          self.save_style();
        },1500);
      }

    },




  }
}
function lengthInUtf8Bytes(str) {
  let m = encodeURIComponent(str).match(/%[89ABab]/g);
  return str.length + (m ? m.length : 0);
}


</script>

<style >

.force_height .v-window__container{
  height:400px;
}

.shadowed{
  color: rgb(255 255 255);
  text-shadow: 2px 2px 2px #b8b8b8;
}
.green_grad{
  background: linear-gradient(0deg, rgba(9,108,7,1) 0%, rgba(32,142,39,1) 35%, rgba(16,218,5,1) 100%) !important;
}

.blue_grad{
  background: linear-gradient(0deg, rgba(8,46,180,1) 0%, rgba(41,62,213,1) 35%, rgba(0,138,255,1) 100%) !important;
}

.purple_grad{
  background: linear-gradient(0deg, rgba(88,8,180,1) 0%, rgba(150,41,213,1) 35%, rgba(154,0,255,1) 100%) !important;
}

.orange_grad{
  background: linear-gradient(0deg, rgba(180,106,8,1) 0%, rgba(213,145,41,1) 35%, rgba(255,196,0,1) 100%) !important;
}
.digi{
  font-family: 'Galindo', cursive;
  font-weight:500;

}

.faded_img{
  filter:saturate(0) brightness(300%);
}

.put_me_down > .v-input__control {
  margin-top: 7px!important;
}
.hover-darken:hover{
  background:rgba(0,0,0,0.1);
}

.display-1 > * input{
  max-height:40px !important;
}

.no_elevate{
  box-shadow:none;
}

.no_scroll > * textarea{
  overflow:hidden;
}

.to_the_left{
  position: relative;
  left:-34px;
}

.flex-center > * .v-input__slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 10px;

}

.color_menu{
  min-width: 0 !important;
}

.color_menu > div{
  margin:0 !important;
}

.v-tabs-bar{
  background: transparent !important;
}




</style>
